import { FeedEntry, FeedParentType } from '~/types/contracting/feed';

import { ChatterSortOrder } from './types';

export const CHATTER_AUDIENCE_LABELS: Record<FeedEntry['audience'], string> = {
  internal: 'The LuxGroup Only',
  all_with_access: 'All with access',
};

export const CHATTER_AUDIENCES = Object.values(CHATTER_AUDIENCE_LABELS);

export const SALESFORCE_OBJECT_BY_PARENT_TYPE: Record<FeedParentType, string> = {
  account: 'Account',
  opportunity: 'Opportunity',
  case: 'Case',
};

export const CHATTER_EDITOR_PLACEHOLDER = 'Share an update...';

// svc-contracting's limits for a post or comment.
export const CHATTER_MAX_BODY_LENGTH = 9000;
export const CHATTER_MAX_MENTIONS = 25;

export const CHATTER_SORT_OPTIONS: Array<{ value: ChatterSortOrder; label: string }> = [
  { value: 'activity', label: 'Most Recent Activity' },
  { value: 'latest', label: 'Latest Posts' },
];
